import axios from 'axios'
import Loader from '@/components/Loader/Loader.vue'
import moment from 'moment'

export default {
  name: 'Form',
  components: { Loader },
  data() {
    return {
      formData: new FormData(),
      loader1: false,
      uploadImageList: [],
      creativeImageList: [],
      progressBar: false,
      showloader: false,
      isdownloadPPT: false,
      POToggle: false,
      ROToggle: false,
      POAmount: '',
      PONumber: '',
      estimateNumber: '',
      estimatAmount: '',
      budgetSpend: '',
      objective: '',
      dealType: '',
      views: '',
      ROAmount: '',
      RONumber: '',
      intervalStatus: '',
      screenShotStatus: '',
      pptStatus: '',
      pptPost: false,
      // form variable
      dateRange: {
        startDate: moment().subtract(1, 'month').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
      },
      brandName: '',
      platform: '',
      approvedBy: '',
      othersApprovedBy: '',
      otherPlatform: '',
      NDA: '',
      NDAFile: '',
      contract: '',
      contractFile: '',
      VRF: '',
      VRFFile: '',
      POCClientDetails: [{
        name: '',
        email: '',
        number: '',
        designation: '',
        lob: [],
        task: 'update'
      }],
      POCInternalDetails: [{
        name: '',
        email: '',
        number: '',
        designation: '',
        lob: [],
        task: 'update'
      }],
      SOW: false,
      SOWFile: '',
      remark: '',
      LOB: '',
      exception: '',
      LobList: ['Media', 'Weavr', 'Ecom', 'SEO', 'Social Media', 'Tech Development', 'Tech Retainer', 'Squarebagel', 'Video', 'Photo/Reels', 'Lyrkl', 'Ekaliedo', 'Automation', 'Bringin'],
      // validation variable 
      brandNameValidation: false,
      platformValidation: false,
      AMemailValidation: false,
      SupEmailValidation: false,
      viewModal: '',
      // NDA generate
      modalFlag: '',
      docusign: false,
      NDAaddress: '',
      designation: '',
      NDAContractValidity: {
        startDate: moment().subtract(1, 'month').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
      },
      nameOfSignNDA: '',
      viewNDATemplateURL: '',
      NDATemplateSign: '',

      // VRF Template Generate
      VRFPayload: {
        docusign: false,
        company_name: "",
        company_address: '',
        country: '',
        city: '',
        state: '',
        pincode: '',
        office_number: '',
        email: '',
        contact_name: '',
        billing_contact_name: '',
        billing_email: '',
        billing_contact_number: '',
        customer_pan: '',
        customer_tan: '',
        customer_gstn: '',
        customer_gst: '',
        invoice_address: '',
        billing_info_address: '',
        date: '',
        designation: '',
        name_of_signee: ''
      },
      VRFTemplateSign: '',
      viewVRFTemplateURL: '',
      VRFContractValidity: {
        startDate: moment().subtract(1, 'month').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
      },
      // contract template
      ContractPayload: {
        date: '',
        name: '',
        business_detail: '', //Business Details in one line
        name_of_signee: '',
        number: '',
        email: '',
        docusign: false,   // False if signature is uploaded mannually
        designation: '',
        address: ''
      },
      contractTemplateValidity: {
        startDate: moment().subtract(1, 'month').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
      },
      ContractTemplateSign: '',
      viewContractTemplateURL: '',
      NDASection: false,
      SOWSection: false,
      VRFSection: false,
      contractSection: false,
      sowBrandName: "",
      selectedSOWLOB: '',
      sowList: [],
      clientLogo: '',
      commisionPercentage: '',
      selectedSOW: {},
      linkedSOWList: [],
      selectedLinkedSow: [],
      addSOWCategory: [],
      removeSOWCategory: [],
      removeSOWValue: [],
      selectedSOWCategory: '',
      enteredSOWValue: '',
      addSOWValueList: [],
      generatedSOWfile: '',
      modalLink: '',
    }
  },
  mounted() {
    this.initializeModal();
  },
  methods: {

    checkdata() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD")
      this.dateRange.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD")
      console.log("check data", this.dateRange)
      this.NDAContractValidity.startDate = moment(this.NDAContractValidity.startDate).format("YYYY-MM-DD")
      this.NDAContractValidity.endDate = moment(this.NDAContractValidity.endDate).format("YYYY-MM-DD")
      this.VRFContractValidity.startDate = moment(this.VRFContractValidity.startDate).format("YYYY-MM-DD")
      this.VRFContractValidity.endDate = moment(this.VRFContractValidity.endDate).format("YYYY-MM-DD")
      this.contractTemplateValidity.startDate = moment(this.contractTemplateValidity.startDate).format("YYYY-MM-DD")
      this.contractTemplateValidity.endDate = moment(this.contractTemplateValidity.endDate).format("YYYY-MM-DD")
    },
    viewModalOpen(flag, link="") {
      this.modalFlag = flag
      this.modalLink = link
      this.viewModal.show()
    },
    initializeModal() {
      const $targetView = document.getElementById('view-data-modal');
      const viewModal = {
        placement: 'center',
        backdrop: 'dynamic',
        backdropClasses: 'bg-gray-900 bg-opacity-50 fixed inset-0 z-40',
        closable: true,
        onHide: () => {
          this.modalLink = '';
        },
        onShow: () => {
          console.log('modal is shown');
        }
      };
      this.viewModal = new Modal($targetView, viewModal);
    },
    uploadNDAfiles(e) {
      console.log(e.target.files)
      this.NDAFile = e.target.files
    },

    uploadContractfiles(e) {
      this.contractFile = e.target.files
    },

    uploadClientLogo(e) {
      this.clientLogo = e.target.files[0]
    },

    uploadSOWfiles(e) {
      console.log(e.target.files)
      this.SOWFile = e.target.files
    },

    uploadVRFfiles(e) {
      this.VRFFile = e.target.files[0]
    },

    addMoreClient() {
      this.POCClientDetails.push({
        name: '',
        email: '',
        number: '',
        designation: '',
        lob: [],
        task: 'update'
      })
    },
    deletePOCfield(id) {
      this.POCClientDetails.splice(id, 1)
    },
    addMorePOC() {
      this.POCInternalDetails.push({
        name: '',
        email: '',
        number: '',
        designation: '',
        lob: [],
        task: 'update'
      })
    },
    deleteInternalPOCfield(id) {
      this.POCInternalDetails.splice(id, 1)
    },
    postDetails() {
      let formData = new FormData()

      //brand name validation, accepts at least 4 characters
      if (this.brandName.length < 4) {
        this.brandNameValidation = true
        return false
      }

      //LOB validation, accepts at least 1 LOB
      if (!this.LOB.length) this.showError(`Please select at least one LOB `)

      //platform validation
      if (!this.platform.length) {
        this.platformValidation = true
        return;
      }

      //client POC fields validation
      this.POCClientDetails.forEach((poc, index) => {
        if (!poc.name) this.showError(`Please enter name for Client POC field ${index + 1}`)
        if (!this.validEmail(poc.email)) this.showError(`Please enter correct email for ${poc.name}`);
        if (!this.validNumber(poc.number)) this.showError(`Please enter correct phone number for ${poc.name}`)
        if (!poc.lob.length) this.showError(`Please select at least one LOB for ${poc.name}`)
        else return poc.lob = poc.lob.toString()
      });

      //L&F POC fields validation
      this.POCInternalDetails.forEach((poc, index) => {
        if (!poc.name) this.showError(`Please enter name for L&F POC field ${index + 1}`)
        if (!this.validEmail(poc.email)) this.showError(`Please enter correct email for ${poc.name}`);
        if (!this.validNumber(poc.number)) this.showError(`Please enter correct phone number for ${poc.name}`)
        if (!poc.lob.length) this.showError(`Please select at least one LOB for ${poc.name}`)
        else return poc.lob = poc.lob.toString()
      });

      this.loader1 = true

      formData.append("brand_name", this.brandName)
      formData.append("lob", this.LOB)

      if (this.platform !== 'others')
        formData.append("platform", this.platform)
      else
        formData.append("platform", this.otherPlatform)

      if (this.approvedBy !== 'etc')
        formData.append("approved_by", this.approvedBy)
      else
        formData.append("approved_by", this.othersApprovedBy)

      formData.append("contract", this.contract ? true : false)
      formData.append("contract_start_date", this.dateRange.startDate)
      formData.append("contract_end_date", this.dateRange.endDate)

      if (this.viewContractTemplateURL) {
        formData.append("contract_file", this.viewContractTemplateURL)
      }
      else if (this.contractFile.length) {
        this.contractFile.forEach(file => formData.append("contract_file", file))
      } else formData.append("contract_file", this.contractFile)

      formData.append("nda", this.NDA ? true : false)
      if (this.viewNDATemplateURL) {
        formData.append("nda_file", this.viewNDATemplateURL)
      }
      else if (this.NDAFile.length) {
        this.NDAFile.forEach(file => formData.append("nda_file", file))
      } else formData.append("nda_file", this.NDAFile)

      formData.append("sow", this.SOW)

      if(this.generatedSOWfile){
        formData.append("sow_file", this.generatedSOWfile)
      } else if (this.SOWFile.length) {
        this.SOWFile.forEach(file => formData.append("sow_file", file))
      } else formData.append("sow_file", this.SOWFile)

      formData.append("vrf", this.VRF ? true : false)
      if (this.viewVRFTemplateURL) {
        formData.append("vrf_file", this.viewVRFTemplateURL)
      }
      else if (this.VRFFile.length) {
        this.VRFFile.forEach(file => formData.append("vrf_file", this.VRFFile))
      } else formData.append("vrf_file", this.VRFFile ? true : false)

      formData.append("poc_client_details", JSON.stringify(this.POCClientDetails))
      formData.append("poc_lyxel_details", JSON.stringify(this.POCInternalDetails))
      formData.append("remark", this.remark)
      formData.append("exception", this.exception)

      let url = '/api/v1/Formfilup'
      axios.post(url, formData).then((response) => {
        this.loader1 = false
        this.$toast.success("Submitted", {
          position: "top-right",
          timeout: 2000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
        this.emptyVariable()

      }).catch((error) => {
        this.loader1 = false
        this.$toast.error(`${error}`, {
          position: "top-right",
          timeout: 2000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
      })
    },
    showError(errorMsg) {
      this.$toast.error(errorMsg, {
        position: "top-right",
        timeout: 3000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
      return;
    },
    showSucess(successMsg) {
      this.$toast.success(successMsg, {
        position: "top-right",
        timeout: 3000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
      return;
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validNumber(number) {
      var no = /^[0-9]{10}$/;
      return no.test(number);
    },
    emptyVariable() {
      this.brandName = ''
      this.LOB = ''
      this.platform = ''
      this.otherPlatform = ''
      this.NDA = false
      this.NDAFile = ''
      this.contract = false
      this.contractFile = ''
      this.SOW = false
      this.VRF = false
      this.VRFFile = false
      this.SOWFile = ''
      this.remark = ''
      this.approvedBy = ''
      this.POCClientDetails = [{
        name: '',
        email: '',
        number: '',
        designation: '',
        lob: [],
        task: 'update'
      }]
      this.POCInternalDetails = [{
        name: '',
        email: '',
        number: '',
        designation: '',
        lob: [],
        task: 'update'
      }]
      this.exception = ''
      this.dateRange = {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
      },
        // validation variable 
        this.brandNameValidation = false
      this.platformValidation = false
    },
    // Generate Template 
    uploadNDASignfiles(e) {
      this.NDATemplateSign = e.target.files[0]
    },
    generateNDATemplate() {
      this.loader1 = true;
      let formData = new FormData();
      formData.append("date", this.NDAContractValidity.startDate)
      formData.append("name", this.brandName)
      formData.append("address", this.NDAaddress)
      formData.append("name_of_signee", this.nameOfSignNDA)
      formData.append("designation", this.designation)
      formData.append("docusign", this.docusign)
      if (!this.docusign) {
        formData.append("signature", this.NDATemplateSign)
      }
      let url = "/api/v1/NDA_Gen"
      axios.post(url, formData).then((res) => {
        this.viewNDATemplateURL = res.data.file_url;
        this.viewModal.hide()
        this.loader1 = false;
        this.showSucess("NDA template generated");
      }).catch(err => {
        console.log("")
        this.loader1 = false;
        this.viewModal.hide();
        this.showError(err);
      })
    },
    generateSOWTemplate() {
      this.loader1 = true;
      let SOWformData = new FormData();
      let tempFormData = new FormData();

      //append linked values to temp form data
      this.linkedSOWList.forEach((list, index) => {
        //validation for empty fields
        if(Object.keys(list).length < 5){
          for(let key of Object.keys(list)){
            if(typeof(this.linkedSOWList[index][key]) === 'object'){
              if(!this.linkedSOWList[index][key+'_str_'+index]){
                this.showError(`${key} is a required field`)
                this.loader1 = false;
                return;
              }
            }
          }
        }
        else {
          for (let key of Object.keys(list)) {
            if (key.includes('str')) {
              let keyStr = key;
              let strArr = keyStr.split("_");
              strArr.pop();
              let joined_Arr = strArr.join("_");
              if(!this.linkedSOWList[index][key].length){
                this.showError(`${this.removeUnderscore(joined_Arr)} is a required field`)
              } else tempFormData.append(joined_Arr, this.linkedSOWList[index][key])
            }
          }
        }
      });

      //club the spread keys, values of temp form data to one single key, value pair
      const groupedData = {};
      tempFormData.forEach((value, key) => {
        if (!groupedData[key]) {
          groupedData[key] = [];
        }
        groupedData[key].push(value);
      });

      //append the clubbed key/value pair to the main form data
      for (let [key, value] of Object.entries(groupedData)) {
        SOWformData.append(key, value);
      }


      //append the direct values to the form data
      SOWformData.append('name', this.sowBrandName);
      SOWformData.append('client_logo', this.clientLogo);
      SOWformData.append('sow_type', this.selectedSOWLOB.toLowerCase());
      SOWformData.append('commission_percentage', this.commisionPercentage);

      //append non-linked values to the form data
      for (let key of Object.keys(this.selectedSOW)) {
        if(!this.selectedSOW[key].length){
          this.showError(`Please fill ${this.removeUnderscore(key)} as it is a required field`);
          this.loader1 = false;
          return;
        }else SOWformData.append(`${key}_str`, this.selectedSOW[key]) 
        
      }


      const url = '/api/v1/SOW_Gen';
      axios.post(url, SOWformData).then(res => {
        console.log(res);
        this.generatedSOWfile = res.data.file_url;
        this.linkedSOWList = [];
        this.selectedSOW = {};
        this.sowList = [];
        this.sowBrandName = "";
        this.clientLogo = "";
        this.selectedSOWLOB = "";
        this.commisionPercentage = "";
        this.viewModal.hide();
        this.showSucess('SOW template generated')
        this.loader1 = false;
      }).catch(err => {
        this.showError(err)
        this.loader1 = false;
      });

    },
    generateVRFTemplate() {
      this.loader1 = true;
      this.VRFPayload.date = this.VRFContractValidity.startDate
      const formDataVRF = new FormData();

      Object.entries(this.VRFPayload).forEach(([key, value]) => {
        formDataVRF.append(key, value)
      })
      if (!this.VRFPayload.docusign) {
        formDataVRF.append("signature", this.VRFTemplateSign)
      }
      console.log("check formdata", formDataVRF)
      let url = "/api/v1/VRF_Gen"
      axios.post(url, formDataVRF).then((res) => {
        this.viewVRFTemplateURL = res.data.file_url;
        this.viewModal.hide()
        this.loader1 = false;
        this.showSucess("VRF template generated");
      }).catch(err => {
        console.log("");
        this.loader1 = false;
        this.viewModal.hide();
        this.showError(err);
      })
    },
    generateContractTemplate() {
      this.loader1 = true;
      this.ContractPayload.date = this.VRFContractValidity.startDate
      const formDataContract = new FormData();

      Object.entries(this.ContractPayload).forEach(([key, value]) => {
        formDataContract.append(key, value)
      })
      if (!this.ContractPayload.docusign) {
        formDataContract.append("signature", this.ContractTemplateSign)
      }
      let url = "/api/v1/Contract_Gen"
      axios.post(url, formDataContract).then((res) => {
        this.viewContractTemplateURL = res.data.file_url;
        this.viewModal.hide()
        this.loader1 = false;
        this.showSucess("Contract template generated");
      }).catch(err => {
        console.log("")
        this.loader1 = false;
        this.viewModal.hide();
        this.showError(err);
      })
    },
    uploadVRFSignfiles(e) {
      this.VRFTemplateSign = e.target.files[0]
    },
    uploadContractSignfiles(e) {
      this.ContractTemplateSign = e.target.files[0]
    },
    getSOWdropdownList() {
      this.loader1 = true;
      const url = '/api/v1/get_sow_dropdown_data';
      let payload = {
        sow_type: this.selectedSOWLOB.toLowerCase()
      };
      this.sowList = [];
      this.linkedSOWList = [];
      this.selectedSOW = {};
      this.addSOWCategory = [];
      this.removeSOWCategory = [];
      this.selectedLinkedSow = [];
      this.removeSOWValue = [];
      axios.get(url, { params: payload }).then(res => {
        this.sowList = res.data.data;
        this.linkedSOWList = res.data.linked_keys;

        //Make a list of SOW dropdown to add and remove SOW(s)
        Object.keys(this.sowList).forEach(key => {
          this.addSOWCategory.push({
            key,
            label: this.removeUnderscore(key)
          })
        });

        this.linkedSOWList.forEach(list => {
          Object.keys(list).forEach(key => {
            this.addSOWCategory.push({
              key,
              label: this.removeUnderscore(key)
            })
          });
        })

        //SOW remove dropdown
        this.removeSOWCategory = { ...this.sowList }
        this.linkedSOWList.forEach(list => {
          Object.assign(this.removeSOWCategory, list)
        })
        // console.log("remove cat list", this.removeSOWCategory)

        // return a new array for v-model of selected options
        this.selectedSOW = { ...this.sowList };

        // empty fields
        for (let categoryValue of Object.keys(this.selectedSOW)) {
          this.selectedSOW[categoryValue] = [];
        };

        for (let linkedItems of this.linkedSOWList) {
          Object.assign(linkedItems, { closeHidden: true });
        };

        this.loader1 = false;
      }).catch(err => {
        console.log(err);
        this.loader1 = false;
      });
    },
    addSelectedLinkedSOW(index, section) {

      //copy the fetched object (section)
      let temp = structuredClone(section);

      //delete the v-model variables out of target section
      for (let key of Object.keys(temp)) {
        if (typeof (temp[key]) === 'string') {
          delete temp[key]
        };

        //toggle the close button
        temp.closeHidden = false;
      };

      //insert the section at the target index
      this.linkedSOWList.splice(index + 1, 0, temp);

      //modify the v-models of the index beyond the target index

      for (let i = index + 2; i < this.linkedSOWList.length; i++) {
        for (let key of Object.keys(this.linkedSOWList[i])) {
          if (typeof (this.linkedSOWList[i][key]) === 'string') {
            let keyStr = key;
            let strArr = keyStr.split("_");
            strArr.pop();
            strArr.push(i);
            let joined_Arr = strArr.join("_");
            Object.assign(this.linkedSOWList[i], this.linkedSOWList[i][joined_Arr]);
            this.linkedSOWList[i][joined_Arr] = this.linkedSOWList[i][key];
            delete this.linkedSOWList[i][key];
          };
        };
      };
    },
    removeSelectedLinkedSOW(index) {
      //remove the element from the target index
      this.linkedSOWList.splice(index, 1);

      //reset the v-models of elements beyond the target index 
      for (let i = index; i < this.linkedSOWList.length; i++) {
        for (let key of Object.keys(this.linkedSOWList[i])) {
          if (typeof (this.linkedSOWList[i][key]) === 'string') {
            let keyStr = key;
            let strArr = keyStr.split("_");
            strArr.pop();
            strArr.push(i);
            let joined_Arr = strArr.join("_");
            Object.assign(this.linkedSOWList[i], this.linkedSOWList[i][joined_Arr]);
            this.linkedSOWList[i][joined_Arr] = this.linkedSOWList[i][key];
            delete this.linkedSOWList[i][key];
          };
        };
      };
    },
    addSOWValue() {
      this.addSOWValueList.push(this.enteredSOWValue)
      this.enteredSOWValue = "";
    },
    addNewSOW() {
      this.loader1 = true;
      const payload = {
        data_list: this.addSOWValueList,
        data_type: this.selectedSOWCategory.key,
        sow_type: this.selectedSOWLOB.toLowerCase()
      }
      const url = '/api/v1/add_sow_dropdown_data';
      axios.post(url, payload).then(res => {
        console.log(res);
        this.selectedSOWCategory = "";
        this.selectedSOWLOB = "";
        this.addSOWValueList = [];
        this.viewModal.hide();
        this.loader1 = false;
        this.showSucess('New SOW(s) added')
      }).catch(err => {
        console.log(err);
        this.selectedSOWCategory = "";
        this.selectedSOWLOB = "";
        this.addSOWValueList = [];
        this.viewModal.hide();
        this.showError(err);
        this.loader1 = false;
      })
    },
    removeExistingSOW() {
      this.loader1 = true;
      const url = '/api/v1/remove_sow_dropdown_data';
      const payload = {
        data: this.removeSOWValue.toString(),
        data_type: this.selectedSOWCategory.key,
        sow_type: this.selectedSOWLOB.toLowerCase()
      }

      axios.post(url, payload).then(res => {
        console.log(res);
        this.selectedSOWCategory = "";
        this.selectedSOWLOB = "";
        this.addSOWValueList = [];
        this.removeSOWValue = [];
        this.viewModal.hide();
        this.loader1 = false;
        this.showSucess('Intended SOW(s) removed');
      }).catch(err => {
        console.log(err);

        this.selectedSOWCategory = "";
        this.selectedSOWLOB = "";
        this.addSOWValueList = [];
        this.removeSOWValue = [];
        this.viewModal.hide();
        this.loader1 = false;
        this.showError(err);
      })
    },
    removeUnderscore(string) {
      if (string.includes("_")) {
        return string.replaceAll("_", " ")
      } else return string
    }
  }
}




